/**
=========================================================
* Zaim engineering - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Box, Button, Tabs, Tab, Skeleton, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import NotificationItem from "components/NotificationItem";
import { useNotifications } from "context/NotificationContext";

function Notifications() {
  const {
    notifications,
    unreadCount,
    isLoading,
    error,
    filter,
    total,
    fetchNotifications,
    loadMoreNotifications,
    setFilter,
  } = useNotifications();

  useEffect(() => {
    fetchNotifications(20, 0, filter);
  }, [filter, fetchNotifications]);

  const handleTabChange = (event, newValue) => {
    setFilter(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <MDTypography variant="h5">Notifications</MDTypography>
                  <MDTypography variant="button" color="text">
                    You have {unreadCount} unread notification{unreadCount !== 1 ? "s" : ""}
                  </MDTypography>
                </Box>
              </MDBox>

              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={filter} onChange={handleTabChange}>
                  <Tab label="All" value="all" />
                  <Tab label={`Unread (${unreadCount})`} value="unread" />
                  <Tab label="Read" value="read" />
                </Tabs>
              </Box>

              {error && (
                <MDBox p={3}>
                  <Typography color="error">{error}</Typography>
                </MDBox>
              )}

              {isLoading ? (
                <Box sx={{ p: 3, backgroundColor: "#ffffff" }}>
                  <Skeleton variant="rectangular" height={80} sx={{ mb: 2 }} />
                  <Skeleton variant="rectangular" height={80} sx={{ mb: 2 }} />
                  <Skeleton variant="rectangular" height={80} />
                </Box>
              ) : notifications.length === 0 ? (
                <MDBox p={3} textAlign="center" sx={{ backgroundColor: "#ffffff" }}>
                  <Typography color="textSecondary">No notifications</Typography>
                </MDBox>
              ) : (
                <Box sx={{ backgroundColor: "#ffffff" }}>
                  {notifications.map((notification) => (
                    <NotificationItem key={notification.id} notification={notification} />
                  ))}
                </Box>
              )}

              {notifications.length < total && !isLoading && (
                <MDBox p={2} textAlign="center">
                  <MDButton variant="gradient" color="info" onClick={loadMoreNotifications}>
                    Load More
                  </MDButton>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Notifications;
